// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-azgv","right":"styles_right__egbu4"};